import React, { useEffect, useState, useCallback, useContext } from "react";
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import { IPost, createPost, updatePost, getPost, deletePost, putFile, getUploadUrl, addMaterial, addDraft, wechatPost, textTranslation } from "../../lib/post";
import { CancelTokenSource } from "axios";
import * as apigw from "../../lib/apigw";
import { useDropzone } from 'react-dropzone';
import { AuthContext } from "../../lib/auth";

export default (props: any) => {

    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
        >
            <div className="p-3">
                {props.modalType === "wechat" && <WechatConnect
                    onHide={props.onHide}
                    handleGetWechatToken={props.handleGetWechatToken}
                />}
                {props.modalType === "twitter" && <TwitterConnect
                    onHide={props.onHide}
                    handleGetTwitterToken={props.handleGetTwitterToken}
                />}
                {props.modalType === "instagram" && <InstagramConnect
                    onHide={props.onHide}
                    handleGetInstagramToken={props.handleGetInstagramToken}
                />}
                {props.modalType === "create" && <CreatePost
                    show={props.show}
                    handleGetPosts={props.handleGetPosts}
                    onHide={props.onHide}
                />}
                {props.modalType === "send" && <SendPost
                    targetPost={props.targetPost}
                    show={props.show}
                    handleGetPosts={props.handleGetPosts}
                    onHide={props.onHide}
                />}
                {props.modalType === "update" && <UpdatePost
                    targetPost={props.targetPost}
                    show={props.show}
                    handleGetPosts={props.handleGetPosts}
                    onHide={props.onHide}
                />}
                {props.modalType === "delete" && <DeletePost
                    targetPost={props.targetPost}
                    show={props.show}
                    handleGetPosts={props.handleGetPosts}
                    onHide={props.onHide}
                />}
            </div >
        </Modal >
    );
}

const WechatConnect = (props: any) => {
    const [attempting, setAttempting] = useState(false)
    const [errorMessages, setErrorMessages] = useState([''])
    const [appid, setAppid] = useState('')
    const [secret, setSecret] = useState('')
    const auth = useContext(AuthContext);

    const handleAppidChange = useCallback((e: any) => setAppid(e.target.value), [])
    const handleSecretChange = useCallback((e: any) => setSecret(e.target.value), [])

    useEffect(() => {
        setErrorMessages([''])
    }, [props.show]);

    const handleConnect = async () => {
        setAttempting(true)
        if (appid && secret) {
            try {
                const json = await auth.setWechat(appid, secret);
                console.log(json);
                props.handleGetWechatToken();
                props.onHide();
            } catch (err) {
                if ((err as any).response?.data) {
                    setErrorMessages([(err as any).response.data]);
                }
            }
        } else {
            setErrorMessages(["入力項目が不足しています"])
        }
        setAttempting(false)
    }

    return (<>
        <div className="p-3">
            <Modal.Title id="contained-modal-title-vcenter">
                WechatアプリIDとシークレット登録
            </Modal.Title>
            <Modal.Body>
                <div className="alet alert-danger">
                    {errorMessages.map((errorMessage: string) => {
                        return errorMessage;
                    })}
                </div>
                <Form
                    className="mb-4">
                    <Form.Label>アプリID<span className="required">必須</span></Form.Label>
                    <Form.Group>
                        <Form.Control
                            type="text"
                            name="appid"
                            value={appid}
                            placeholder="アプリID"
                            disabled={attempting}
                            onChange={handleAppidChange}
                            maxLength={255}
                            className="mb-1" />
                    </Form.Group>
                    <Form.Label>シークレット<span className="required">必須</span></Form.Label>
                    <Form.Group>
                        <Form.Control
                            type="text"
                            name="secret"
                            value={secret}
                            placeholder="シークレット"
                            disabled={attempting}
                            onChange={handleSecretChange}
                            maxLength={255} />
                    </Form.Group>
                    <Button
                        className="btn-info"
                        disabled={attempting}
                        onClick={handleConnect}
                        block>連携</Button>
                    <Button onClick={props.onHide} variant="secondary" block>キャンセル</Button>
                </Form>
            </Modal.Body>
        </div>
    </>)

}

const TwitterConnect = (props: any) => {
    const [attempting, setAttempting] = useState(false)
    const [errorMessages, setErrorMessages] = useState([''])
    const [appid, setAppid] = useState('')
    const auth = useContext(AuthContext);

    const handleAppidChange = useCallback((e: any) => setAppid(e.target.value), [])

    useEffect(() => {
        setErrorMessages([''])
    }, [props.show]);

    const handleConnect = async () => {
        setAttempting(true)
        if (appid) {
            try {
                const json = await auth.setTwitter(appid);
                console.log(json);
                props.handleGetTwitterToken();
                props.onHide();
            } catch (err) {
                if ((err as any).response?.data) {
                    setErrorMessages([(err as any).response.data]);
                }
            }
        } else {
            setErrorMessages(["入力項目が不足しています"])
        }
        setAttempting(false)
    }

    return (<>
        <div className="p-3">
            <Modal.Title id="contained-modal-title-vcenter">
                TwitterアプリID登録
            </Modal.Title>
            <Modal.Body>
                <div className="alet alert-danger">
                    {errorMessages.map((errorMessage: string) => {
                        return errorMessage;
                    })}
                </div>
                <Form
                    className="mb-4">
                    <Form.Label>アプリID<span className="required">必須</span></Form.Label>
                    <p className="text-muted">@*****の@以下の*****をご入力ください</p>
                    <Form.Group>
                        <Form.Control
                            type="text"
                            name="appid"
                            value={appid}
                            placeholder="アプリID"
                            disabled={attempting}
                            onChange={handleAppidChange}
                            maxLength={255}
                            className="mb-1" />
                    </Form.Group>
                    <Button
                        className="btn-info"
                        disabled={attempting}
                        onClick={handleConnect}
                        block>連携</Button>
                    <Button onClick={props.onHide} variant="secondary" block>キャンセル</Button>
                </Form>
            </Modal.Body>
        </div>
    </>)
}

const InstagramConnect = (props: any) => {
    const [attempting, setAttempting] = useState(false)
    const [errorMessages, setErrorMessages] = useState([''])
    const [id, setId] = useState('')
    const [token, setToken] = useState('')
    const auth = useContext(AuthContext);

    const handleIdChange = useCallback((e: any) => setId(e.target.value), [])
    const handleTokenChange = useCallback((e: any) => setToken(e.target.value), [])

    useEffect(() => {
        setErrorMessages([''])
    }, [props.show]);

    const handleConnect = async () => {
        setAttempting(true)
        if (id && token) {
            try {
                const json = await auth.setInstagram(id, token);
                console.log(json);
                props.handleGetInstagramToken();
                props.onHide();
            } catch (err) {
                if ((err as any).response?.data) {
                    setErrorMessages([(err as any).response.data]);
                }
            }
        } else {
            setErrorMessages(["入力項目が不足しています"])
        }
        setAttempting(false)
    }

    return (<>
        <div className="p-3">
            <Modal.Title id="contained-modal-title-vcenter">
                InstagramIDとアクセストークン
            </Modal.Title>
            <Modal.Body>
                <div className="alet alert-danger">
                    {errorMessages.map((errorMessage: string) => {
                        return errorMessage;
                    })}
                </div>
                <Form
                    className="mb-4">
                    <Form.Label>Instagram ID<span className="required">必須</span></Form.Label>
                    <Form.Group>
                        <Form.Control
                            type="text"
                            name="id"
                            value={id}
                            placeholder="Instagram ID"
                            disabled={attempting}
                            onChange={handleIdChange}
                            maxLength={255}
                            className="mb-1" />
                    </Form.Group>
                    <Form.Label>アクセストークン<span className="required">必須</span></Form.Label>
                    <Form.Group>
                        <Form.Control
                            type="text"
                            name="token"
                            value={token}
                            placeholder="アクセストークン"
                            disabled={attempting}
                            onChange={handleTokenChange}
                            maxLength={255} />
                    </Form.Group>
                    <Button
                        className="btn-info"
                        disabled={attempting}
                        onClick={handleConnect}
                        block>連携</Button>
                    <Button onClick={props.onHide} variant="secondary" block>キャンセル</Button>
                </Form>
            </Modal.Body>
        </div>
    </>)

}

const CreatePost = (props: any) => {
    const [errorMessages, setErrorMessages] = useState<string[]>([""]);
    const handleTextChange = useCallback((e: any) => setText(e.target.value), []);
    const [text, setText] = useState<string>("");
    const [media, setMedia] = useState<string>("");
    const [isUploaded, setIsUploaded] = useState(false);

    const MAX_MEDIA_SIZE = 5242880
    const MIN_MEDIA_SIZE = 0

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': [".png", ".jpg", ".jpeg", ".gif"]
        }
    });

    useEffect(() => {
        if (acceptedFiles.length) {
            if (acceptedFiles[0].type.includes("image/")) {
                if (acceptedFiles[0].size > MIN_MEDIA_SIZE && acceptedFiles[0].size <= MAX_MEDIA_SIZE) {
                    fileUpload(acceptedFiles[0]);
                } else {
                    setErrorMessages(["file size is invalid"]);
                }
            } else {
                setErrorMessages(["file is invalid"]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acceptedFiles]);

    const fileUpload = async (file: any) => {
        try {
            setIsUploaded(true);
            const extend = file.name.match(/[^.]+$/);
            const filename = "we_marke_image." + extend;
            const put_json = await getUploadUrl(filename, file.type);
            if (put_json) {
                const url = put_json?.data;
                //S3への一時アップロード
                await putFile(url, file);
                setMedia(url.split("?Content-Type=")?.[0]);
            }
            setIsUploaded(false);
        } catch (err) {
            setIsUploaded(false);
            setErrorMessages(["Error"]);
        }
    }

    //Modalが表示・非表示になるたびにerrorMessageを空にする
    useEffect(() => {
        setErrorMessages([""])
    }, [props.show]);

    const handleCreate = async () => {
        if (!text && !media) {
            setErrorMessages(["コンテンツが見つかりません"]);
        } else {
            try {
                await createPost(text, media);
                props.handleGetPosts(true);
                props.onHide();
            } catch (err) {
                setErrorMessages(["ERROR"]);
                console.log(err)
            }
        }
    }

    return (
        <>
            <Modal.Title id="contained-modal-title-vcenter">
                <div className="mr-2">投稿作成</div>
                <hr />
            </Modal.Title>
            <Modal.Body className="pt-0">
                <p className="text-muted">Wechatへの投稿の際には最初の30文字、もしくは最初の改行までがタイトルとして投稿されます。</p>
                <div className="alet alert-danger">
                    {errorMessages.map((errorMessage: string) => {
                        return errorMessage;
                    })}
                </div>
                {isUploaded && <>Uploading...</>}
                {!isUploaded && <>
                    <Form.Group>
                        <p className="text-muted">アップロードする画像は5Mまで。PNG\JPEG\JPG\GIF 形式</p>
                        <div {...getRootProps({ className: 'dropzone border mb-3 text-center p-3' })}>
                            <input {...getInputProps()} id="file" />
                            <p className="mt-3 small">
                                画像をドラッグアンドドロップ、<br />または選択してアップロードしてください。<br />
                            </p>
                        </div>
                        {media && <img src={media} className="w-100" alt="Media" />}
                    </Form.Group>
                    <Form.Group>
                        <Form.Control
                            as="textarea"
                            rows={10}
                            maxLength={300}
                            data-name="summary"
                            value={text}
                            onChange={handleTextChange}
                        />
                    </Form.Group>
                    < Button onClick={handleCreate} variant="primary" block>
                        <span>作成</span>
                    </Button>
                    <Button onClick={props.onHide} variant="secondary" block>キャンセル</Button>
                </>}
            </Modal.Body>
        </>
    )
}

const UpdatePost = (props: any) => {
    const [cancelTokenSource] = useState<CancelTokenSource>(apigw.getCancelTokenSource());
    const [post, setPost] = useState<IPost>();
    const [errorMessages, setErrorMessages] = useState<string[]>([""]);
    const handleTextChange = useCallback((e: any) => setText(e.target.value), []);
    const [text, setText] = useState<string>("");
    const [media, setMedia] = useState<string>("");
    const [isUploaded, setIsUploaded] = useState(false);
    const [isLoaded, setIsLoaded] = useState<boolean>(true);

    const MAX_MEDIA_SIZE = 5242880
    const MIN_MEDIA_SIZE = 0

    const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
        accept: {
            'image/*': [".png", ".jpg", ".jpeg", ".gif"]
        }
    });

    useEffect(() => {
        handleGetPost();
        return () => cancelTokenSource.cancel("Component unmounted, request is cancelled.")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setText(post?.text || "");
        setMedia(post?.media || "");
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [post]);

    const handleGetPost = async () => {
        try {
            const post_json = await getPost(props.targetPost, { cancelToken: cancelTokenSource.token });
            setPost(post_json?.data);
            setIsLoaded(false);
        } catch (err) {
            props.onHide();
        }
    }

    useEffect(() => {
        if (acceptedFiles.length) {
            if (acceptedFiles[0].type.includes("image/")) {
                if (acceptedFiles[0].size > MIN_MEDIA_SIZE && acceptedFiles[0].size <= MAX_MEDIA_SIZE) {
                    fileUpload(acceptedFiles[0]);
                } else {
                    setErrorMessages(["file size is invalid"]);
                }
            } else {
                setErrorMessages(["file is invalid"]);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [acceptedFiles]);

    const fileUpload = async (file: any) => {
        try {
            setIsUploaded(true);
            const extend = file.name.match(/[^.]+$/);
            const filename = "we_marke_image." + extend;
            const put_json = await getUploadUrl(filename, file.type);
            if (put_json) {
                const url = put_json?.data;
                //S3への一時アップロード
                await putFile(url, file);
                setMedia(url.split("?Content-Type=")?.[0]);
            }
            setIsUploaded(false);
        } catch (err) {
            setIsUploaded(false);
            setErrorMessages(["Error"]);
        }
    }

    //Modalが表示・非表示になるたびにerrorMessageを空にする
    useEffect(() => {
        setErrorMessages([""])
    }, [props.show]);

    const handleUpdate = async () => {
        if (!text && !media) {
            setErrorMessages(["コンテンツが見つかりません"]);
        } else if (post?.status && +post?.status === 2) {
            setErrorMessages(["投稿済の投稿のため更新できません"]);
        } else if (!post?.id) {
            setErrorMessages(["IDが見つかりません"]);
        } else {
            try {
                await updatePost(post?.id, text, media);
                props.handleGetPosts(true);
                props.onHide();
            } catch (err) {
                setErrorMessages(["ERROR"]);
                console.log(err)
            }
        }
    }

    return (
        <>
            <Modal.Title id="contained-modal-title-vcenter">
                <div className="mr-2">投稿更新</div>
                <hr />
            </Modal.Title>
            <Modal.Body className="pt-0">
                <p className="text-muted">Wechatへの投稿の際には最初の30文字、もしくは最初の改行までがタイトルとして投稿されます。</p>
                {isLoaded && <div className="w-100 text-center">
                    <Spinner animation="border" variant="info" />
                </div>}
                {!isLoaded && <>
                    <div className="alet alert-danger">
                        {errorMessages.map((errorMessage: string) => {
                            return errorMessage;
                        })}
                    </div>
                    {isUploaded && <>Uploading...</>}
                    {!isUploaded && <>
                        <Form.Group>
                            <p className="text-muted">アップロードする画像は5Mまで。PNG\JPEG\JPG\GIF 形式</p>
                            <div {...getRootProps({ className: 'dropzone border mb-3 text-center p-3' })}>
                                <input {...getInputProps()} id="file" />
                                <p className="mt-3 small">
                                    画像をドラッグアンドドロップ、<br />または選択してアップロードしてください。<br />
                                </p>
                            </div>
                            {media && <img src={media} className="w-100" alt="Media" />}
                        </Form.Group>
                        <Form.Group>
                            <p className="text-muted">テキストは300文字まで</p>
                            <Form.Control
                                as="textarea"
                                rows={10}
                                data-name="summary"
                                value={text}
                                onChange={handleTextChange}
                            />
                        </Form.Group>
                        <Button onClick={handleUpdate} variant="primary" block>
                            <span>更新</span>
                        </Button>
                        <Button onClick={props.onHide} variant="secondary" block>キャンセル</Button>
                    </>}
                </>}
            </Modal.Body>
        </>
    )
}

const SendPost = (props: any) => {
    const [errorMessages, setErrorMessages] = useState<string[]>([""]);
    const [cancelTokenSource] = useState<CancelTokenSource>(apigw.getCancelTokenSource());
    const [post, setPost] = useState<IPost>();
    const [cnText, setCnText] = useState<string>("");
    const [isLoaded, setIsLoaded] = useState<boolean>(true);
    const [postLoaded, setPostLoaded] = useState<boolean>(false);
    const [translationOn, setTranslationOn] = useState<boolean>(true);
    const handleTranslationOnChange = (e: any) => {
        setTranslationOn(e.target.checked)
    }
    const auth = useContext(AuthContext);

    useEffect(() => {
        handleGetPost();
        return () => cancelTokenSource.cancel("Component unmounted, request is cancelled.")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleGetPost = async () => {
        try {
            const post_json = await getPost(props.targetPost, { cancelToken: cancelTokenSource.token });
            setPost(post_json?.data);
            setIsLoaded(false);
        } catch (err) {
            props.onHide();
        }
    }

    useEffect(() => {
        if (post && post.text) {
            handleTextTranslation(post.text);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [post]);

    const handleTextTranslation = async (text: string) => {
        setPostLoaded(true);
        try {
            const json = await textTranslation(text);
            setCnText(json.data?.message);
        } catch (err) {
            setErrorMessages(["翻訳に失敗しました"]);
            setTranslationOn(false);
            setCnText("");
        }
        setPostLoaded(false);
    }

    const handleNewsSend = async (e: any) => {
        if (post && post.id) {
            setPostLoaded(true);
            try {
                const wechatInfo = await auth.getWechat();
                if (wechatInfo.data.accessToken) {
                    if (post.media && post.text) {
                        //画像のアップ
                        const materiarlInfo = await addMaterial(post.media, wechatInfo.data.accessToken);
                        //Newsのアップ
                        let text = ""
                        if (translationOn && cnText) {
                            text = cnText
                        } else {
                            text = post.text
                        }
                        const content = "<img src=\"" + materiarlInfo?.data.url + "\" /><div>" + text + "</div>";
                        const thumb_media_id = materiarlInfo?.data.media_id;
                        const draftInfo = await addDraft(text, content, thumb_media_id, wechatInfo.data.accessToken);
                        //Newsの投稿
                        const json = await wechatPost(post.id, draftInfo?.data.media_id, wechatInfo.data.accessToken);
                        console.log(json);
                        props.handleGetPosts(true);
                        props.onHide();
                    } else {
                        setErrorMessages(["投稿するには画像とテキストの両方が必要です"]);
                    }
                }
            } catch (err) {
                console.log(err)
                setErrorMessages(["一日の投稿制限に達した可能性があります"]);
            }
            setPostLoaded(false);
        } else {
            props.onHide();
        }

    }

    return (
        <>
            <Modal.Title id="contained-modal-title-vcenter">
                <div className="mr-2">投稿</div>
                <hr />
            </Modal.Title>
            {postLoaded && <div className="w-100 text-center">
                <Spinner animation="border" variant="info" />
            </div>}
            {!postLoaded && <>
                <Modal.Body className="pt-0">
                    <p className="text-muted">Wechatへの投稿の際には最初の30文字、もしくは最初の改行までがタイトルとして投稿されます。</p>
                    <div className="alet alert-danger">
                        {errorMessages.map((errorMessage: string) => {
                            return errorMessage;
                        })}
                    </div>
                    {isLoaded && <div className="w-100 text-center">
                        <Spinner animation="border" variant="info" />
                    </div>}
                    {!isLoaded && <>
                        {post &&
                            <div className="row">
                                {post.text && cnText &&
                                    <div className="col-12 p-1">
                                        <Form>
                                            <Form.Group>
                                                <Form.Check
                                                    type="switch"
                                                    label="翻訳されたテキストを投稿する"
                                                    id={`translation`}
                                                    onChange={handleTranslationOnChange}
                                                    checked={translationOn}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </div>
                                }
                                {post.text &&
                                    <div className={translationOn ? "col-12 p-1 bg-secondary" : "col-12 p-1"}>
                                        {post.text}
                                    </div>
                                }
                                {cnText &&
                                    <div className={translationOn ? "col-12 p-1" : "col-12 p-1 bg-secondary"}>
                                        {cnText}
                                    </div>
                                }
                                <div className="col-12 p-1">
                                    {post.media && <img src={post.media} className="w-100" alt="Media" />}
                                </div>
                                <div className="col-12 p-1">
                                    {post.create_date}
                                </div>
                            </div>
                        }
                        <Button onClick={handleNewsSend} block className="my-2">
                            <span>News投稿</span>
                        </Button>
                        <Button onClick={props.onHide} variant="secondary" block>キャンセル</Button>
                    </>}
                </Modal.Body>
            </>}
        </>
    )

}

const DeletePost = (props: any) => {
    const [cancelTokenSource] = useState<CancelTokenSource>(apigw.getCancelTokenSource());
    const [post, setPost] = useState<IPost>();
    const [isLoaded, setIsLoaded] = useState<boolean>(true);

    useEffect(() => {
        handleGetPost();
        return () => cancelTokenSource.cancel("Component unmounted, request is cancelled.")
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleGetPost = async () => {
        try {
            const post_json = await getPost(props.targetPost, { cancelToken: cancelTokenSource.token });
            setPost(post_json?.data);
            setIsLoaded(false);
        } catch (err) {
            props.onHide();
        }
    }

    const handleDelete = async (e: any) => {
        if (post && post.id) {
            try {
                await deletePost(post.id);
                props.handleGetPosts(true);
                props.onHide();
            } catch (err) {
                props.onHide();
            }
        }
    }

    return (
        <>

            <Modal.Title id="contained-modal-title-vcenter">
                <div className="mr-2">投稿削除</div>
                <hr />
            </Modal.Title>
            <Modal.Body className="pt-0">
                <p className="text-muted">Wechatに投稿済の場合、Wechatからは削除されません。</p>
                {isLoaded && <div className="w-100 text-center">
                    <Spinner animation="border" variant="info" />
                </div>}
                {!isLoaded && <>
                    {post &&
                        <div className="row">
                            <div className="col-12 p-1">
                                {post.text}
                            </div>
                            <div className="col-12 p-1">
                                {post.media && <img src={post.media} className="w-100" alt="Media" />}
                            </div>
                            <div className="col-12 p-1">
                                {post.create_date}
                            </div>
                        </div>
                    }
                    <Button onClick={handleDelete} block className="my-2">
                        <span>削除</span>
                    </Button>
                    <Button onClick={props.onHide} variant="secondary" block>キャンセル</Button>
                </>}
            </Modal.Body>
        </>
    )

}